import { SectionLayout } from "@/components/layout/section-layout";
import { useWeeklyChangeCount } from "@/lib/hooks/use-header-monitoring";
import { useSiteScope } from "@/lib/hooks/use-site-scope";
import { formatNumber } from "@/lib/utils/format-number";

/**
 * Headers' tab row (ADR 013), with the Changes tab's count of the last week's
 * changes (task 374) so a change is visible from the Pages tab too. The count
 * is the scoped site's, or every site's under "all sites"; nothing is drawn
 * until it is known, and nothing when it is zero.
 */
export function HeadersLayout() {
  const { siteId, sites } = useSiteScope();
  const count = useWeeklyChangeCount(
    siteId ? [siteId] : sites.map((site) => site.id),
  );

  return (
    <SectionLayout
      section="headers"
      tabBadges={
        count
          ? {
              "/dashboard/headers/changes": (
                <span
                  className="ml-2 rounded-full bg-muted px-2 py-0.5 text-xs font-medium text-foreground"
                  data-testid="header-changes-badge"
                >
                  {formatNumber(count)} this week
                </span>
              ),
            }
          : undefined
      }
    />
  );
}
